import React from 'react'

import { Span } from 'components'
import { COLORS } from 'utils'

import { TitleContainer, Content, Container } from './CardChart.styles'

interface ICardChart {
  titleCard: string
  margin?: string
}
const CardChart: React.FC<ICardChart> = ({ children, titleCard, margin }) => {
  return (
    <Container margin={margin}>
      <TitleContainer>
        <Span
          text={titleCard}
          fontSize="23px"
          color={COLORS.blueFonts}
          fontWeight="700"
        />
      </TitleContainer>
      <Content>{children}</Content>
    </Container>
  )
}

export default CardChart
